<template>
    <div class="row voffset1">
        <ul class="list-inline text-center">
            <li v-for="(patientNumber, index) in nbPatients">
                <div v-if="index < nbPatientsFilled">
                    <a @click.prevent="changePatient({newPatient: patientNumber, button: false})" href="#">
                        <i class="fa fa-user" :style="'color:' + colorPatient(patientNumber) + ';font-size:' + scalePatient(patientNumber)" aria-hidden="true"></i>
                        <p>Patient {{ patientNumber }}</p>
                    </a>
                </div>
                <div v-else>
                    <p>
                        <i class="fa fa-user" :style="'color:' + colorPatient(patientNumber) + ';font-size:' + scalePatient(patientNumber)" aria-hidden="true"></i>
                        <p>Patient {{ patientNumber }}</p>
                    </a>
                </div>
            </li>
        </ul>
    </div>
</template>

<script>
    export default {
        components: {
        },
        computed: {
            currentPatient: function() {
                return this.$store.state.user.currentPatient;
            },
            nbPatients: function() {
                return this.$store.state.user.nbPatients;
            },
            nbPatientsFilled: function() {
                return this.$store.getters.nbPatientsFilled;
            }
        },
        methods: {
            changePatient(patientNumber) {
                this.$store.dispatch('changePatient', patientNumber);
            },
            scalePatient(patientNumber)  {
                if (this.currentPatient == patientNumber)   {
                    return '6em';
                }
                return '5em';
            },
            colorPatient(patientNumber)  {
                if (this.currentPatient == patientNumber)
                    return 'darkorange';
                if (patientNumber <= this.nbPatientsFilled)
                    return 'darkgreen';
                return 'grey';
            }
        }
    };
</script>
